import { useDsTranslateMessage } from '@mc/wink/internationalization/useDsTranslateMessage';

// Translation for Pagination default values
export const TranslatePagination = (totalPages?: number) => {
  return {
    goToFirstPageLabel: useDsTranslateMessage({
      id: 'mcds.pagination.go_to_first_page',
      defaultMessage: 'Go to first page',
    }),
    goToLastPageLabel: useDsTranslateMessage({
      id: 'mcds.pagination.go_to_last_page',
      defaultMessage: 'Go to last page',
    }),
    goToNextPageLabel: useDsTranslateMessage({
      id: 'mcds.pagination.go_to_next_page',
      defaultMessage: 'Go to next page',
    }),
    goToPreviousPageLabel: useDsTranslateMessage({
      id: 'mcds.pagination.go_to_previous_page',
      defaultMessage: 'Go to previous page',
    }),
    navigationLabel: useDsTranslateMessage({
      id: 'mcds.pagination.navigation_label',
      defaultMessage: 'Pagination navigation',
    }),
    nextText: useDsTranslateMessage({
      id: 'mcds.pagination.next',
      defaultMessage: 'Next',
    }),
    ofText: useDsTranslateMessage({
      id: 'mcds.pagination.of',
      defaultMessage: ' of ',
    }),
    pageNumberLabelText: useDsTranslateMessage({
      id: 'mcds.pagination.page_number_label_text',
      defaultMessage: `Page number, enter a value between 1 and ${totalPages}`,
      values: { totalPages: totalPages },
    }),
    previousText: useDsTranslateMessage({
      id: 'mcds.pagination.previous',
      defaultMessage: 'Previous',
    }),
  };
};
